import React, { useMemo } from "react";
import { formatearPreciosDos } from "../../../../../utils/precios.js";
import TablaGenerica from "../../../../componentsUI/tablas/tablaGenerica.js"; // tu genérica

export default function TablaDetalleCompuesto({
  productoSeleccionado,
  paginaActual,
  cambiarPagina,
  totalPaginas,
  rowsPerPage = 5,
}) {
  const dummy = [
    {
      Codigo: 999,
      nombre: "Producto Demo",
      Clase: "Clase A",
      producto_insumo: "115",
      nombre_insumo: "Insumo A",
      cantidad: 2,
      costo_insumo: 1500,
      unidad: "UND",
    },
    {
      Codigo: 999,
      nombre: "Producto Demo",
      Clase: "Clase A",
      producto_insumo: "16",
      nombre_insumo: "Insumo B",
      cantidad: 1,
      costo_insumo: 3200,
      unidad: "UND",
    },
  ];

  const data = productoSeleccionado?.length > 0 ? productoSeleccionado : dummy;
  const producto = data[0];

  const totalCosto = useMemo(() => {
    return data.reduce(
      (acc, item) => acc + (item.cantidad * item.costo_insumo || 0),
      0,
    );
  }, [data]);

  const headers = ["Insumo", "Cant.", "Unidad", "Costo Unit", "Total"];

  return (
    <div>
    <TablaGenerica
    className="tabla-cambios"
      titulo={`${producto?.nombre || "Producto"} - $ ${ formatearPreciosDos (producto?.precio_unitario) || ""}- ${producto?.Clase || ""}`}
      headers={headers}
      data={data}
      rowsPerPage={rowsPerPage}
      paginaActual={paginaActual}
      cambiarPagina={cambiarPagina}
      totalPaginas={totalPaginas}
      renderRow={(item, index) => {
        const totalLinea = item.cantidad * item.costo_insumo;
        return (
          <tr key={item.producto_insumo}>
            <td className="col-1">
              {item.producto_insumo}- {item.nombre_insumo}
            </td>
            <td className="col-2">{item.cantidad}</td>
            <td className="col-3">{item.unidad}</td>
            <td className="col-4">{formatearPreciosDos(item.costo_insumo)}</td>
            <td className="col-5">{formatearPreciosDos(totalLinea)}</td>
          </tr>
        );
      }}
      footer={() => (
        <tr className="footer">
          <td colSpan={headers.length - 1}>Total Insumos</td>
          <td> {formatearPreciosDos(totalCosto)}</td>
        </tr>
      )}
    />
    </div>
  );
}
